import { Base2Presenter } from "core/presenter";
import { ProductRepository } from "core/repository";
import * as R from "ramda";

class ProductFormKitInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      productSearchOptions: {
        repository: ProductRepository,
        order: [{ field: "name", direction: "ASC" }],
        pagination: { page: 1, perPage: 25 },
        filter: filter => this.getFilter(filter)
      },
      loading: true,
      allProducts: [],
      items: [],
      productsUuids: {}
    };
  }

  async onChangeProps() {
    await this.enqueue({
      productsUuids: R.clone(this.props.product.products_uuids)
    });
    await this.getAllProducts();
    this.editKit();
  }

  addProduct() {
    const item = { name: "", uuid: "", quantity: 0 };
    this.enqueue(vm => ({ items: [...vm.items, item] }));
    this.parseForObject();
  }

  onDeleteItem(index) {
    const items = this.viewModel.items[index];
    const name = items.name;

    if (this.props.mode === "add") {
      return this.doDelete(index);
    }

    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir o produto ${name} do kit?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDelete(index)
        }
      ]
    });
  }

  doDelete(index) {
    this.enqueue(
      vm => {
        const items = [...vm.items];
        items.splice(index, 1);
        return { items };
      },
      () => this.parseForObject()
    );
  }

  onSelectProduct(index, sellable) {
    this.enqueue(vm => {
      const items = [...vm.items];
      items[index]["name"] = sellable.name;
      items[index]["uuid"] = sellable.uuid;
      return { items };
    });
  }

  onChange(field, index, value) {
    this.enqueue(
      vm => {
        vm.items[index][field] = value.replace(/(\D|^0+)/g, "");
        return { items: vm.items };
      },
      () => this.parseForObject()
    );
  }

  parseForObject() {
    const { items } = this.viewModel;
    this.props.product.products_uuids = items.reduce((productsUuids, item) => {
      if (item.name) {
        return {
          ...productsUuids,
          [item.uuid]: item.quantity
        };
      }

      return this.sendNotification({
        type: "error",
        title: "Oooops...",
        content: "Você deve selecionar um produto para compor o kit/combo."
      });
    }, {});
  }

  editKit() {
    const { productsUuids } = this.viewModel;
    const items = [];

    if (this.props.mode === "edit") {
      if (!!productsUuids) {
        Object.entries(productsUuids).forEach(([field, content]) =>
          items.push({
            uuid: field,
            quantity: content,
            name: this.getProductName(field)
          })
        );

        this.enqueue({ items });
      }
    }
  }

  getFilter(value) {
    const { items } = this.viewModel;
    const selectedUuids = items.map(item => item.uuid);

    return [
      { field: "name", operation: "LIKE", value },
      { connector: "AND", field: "deleted", operation: "EQ", value: "false" },
      { connector: "AND", field: "type", operation: "EQ", value: "product" },
      {
        connector: "AND",
        field: "uuid",
        operation: "NIN",
        value: selectedUuids.join("|")
      }
    ];
  }

  getProductName(uuid) {
    const product = this.viewModel.allProducts.find(
      product => product.uuid === uuid
    ) || { name: "" };
    return product.name;
  }

  async getAllProducts() {
    const { productsUuids } = this.viewModel;

    if (!!productsUuids) {
      const products = Object.keys(productsUuids).map(async uuid => {
        const repositoryResult = await ProductRepository.get(uuid);
        return repositoryResult.success ? repositoryResult.data : null;
      });

      const allProducts = await Promise.all(products);

      if (allProducts.includes(null)) {
        this.sendNotification({
          type: "error",
          title: "Oooops...",
          content:
            "Não conseguimos carregar os produtos do kit! Tente novamente em alguns minutos ou entre em contato com o suporte."
        });
      } else {
        this.enqueue({ allProducts });
      }
    }

    this.enqueue({ loading: false });
  }
}

export default ProductFormKitInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/kit-info/presenter.js